import Vue from 'vue';
import VueI18n from 'vue-i18n';
import translations from '@/assets/json/translations.json';

Vue.use(VueI18n);

function loadLocaleMessages() {
  return translations[0].rows.reduce((obj, messages) => {
    obj[messages.language] = messages;
    return obj;
  }, {});
}

// using lang param to set language
const search = new URLSearchParams(window.location.search);
const lang = search.get('lang');
let locale;
if (lang === 'fr') {
  locale = 'fr';
} else if (lang === 'de') {
  locale = 'de';
} else {
  locale = process.env.VUE_APP_I18N_LOCALE;
}

export default new VueI18n({
  locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'de',
  messages: loadLocaleMessages()
});
